import React, {useEffect, useState} from "react";
import AddDailyReport from "./components/AddDailyReport";
import ChatDisplayButton from "./components/ChatDisplayButton";
import Loading from "../Loading";
import Icon from "../utils/Icon";
import { useDashboardContext } from "../../context/DashboardContext";
import { fetchCompanyInfoData } from "../api/api_calls";
import { useNavigate,useLocation } from 'react-router-dom';


const Header = ({ secCode, displayDailyReportSettings, isRegistered, addCompany, removeCompany, displayWhatIsDailyReport, toggleChat, chatDefaultSetting }) => {
    const [showHpToolTip, setShowHpTooltip] = useState(false);
    const { state: dashboardState, dispatch: dashboardDispatch } = useDashboardContext();
    const [companyInfo, setCompanyInfo] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const getComapnyInfo = async () => {
            if (dashboardState.companyInfo) {
                setCompanyInfo(dashboardState.companyInfo);
            }
        }
        if (secCode) {
            getComapnyInfo();
        }
    }, [secCode, dashboardState.companyInfo])
    
    
    if (!companyInfo) {
        return <div></div>
    }

    const WebSite = ({companyInfo}) => {
        let url;
        if (companyInfo.country === 'JP') {
            if (companyInfo.url_japan)
                url = companyInfo.url_japan;
            else {
                url = null;
            }
        } else {
            if (companyInfo.website) {
                url = companyInfo.website;
            } else {
                url = null;
            }
        }

        if (url) {
            return (
                <div className="text-lg py-[5px] px-[5px] h-[35px] hover:bg-[lightgrey] rounded-md" onMouseEnter={() => setShowHpTooltip(true)} onMouseLeave={() => setShowHpTooltip(false)}>
                    <a className="company-hp-url-a" target="_blank" href={url}><i className="fa-solid fa-arrow-up-right-from-square hp-link" ></i></a>
                    {showHpToolTip && <div className="absolute top-[110%] left-1/2 transform -translate-x-1/2 bg-gray-600 text-white text-xs py-2 px-2 rounded shadow-md w-[140px]">企業 HP を開く</div>}
                </div>
                
            )
        } else {
            return null
        }
    }

    return (
        <div id="header-container">
            <div id="header" className="flex pt-1">
                <div className="dashboard-company-name">
                    <div className="flex">
                        <div className="w-[30px] h-[30px] md:w-[40px] md:h-[40px] mr-3"><Icon secCode={secCode} companyImageUrl={companyInfo.image} /></div>
                        <div className="flex items-top">{companyInfo.company_name} 【{secCode}】</div>
                    </div>
                </div>
                <WebSite companyInfo={companyInfo} />
                {/* <AddDailyReport displayDailyReportSettings={displayDailyReportSettings}  secCode={secCode} isRegistered={isRegistered} addCompany={addCompany} removeCompany={removeCompany} displayWhatIsDailyReport={displayWhatIsDailyReport} /> */}
                <ChatDisplayButton toggleChat={toggleChat} defaultSetting={chatDefaultSetting} />
            </div>
        </div>
    );
};

export default Header;
